import request from "../plugins/request";

/** 获取火点报警记录 */
export const getFireWarningRecords = () =>
  request({
    url: "/api/realTimeSchedule/getFireWarningRecords",
    method: "get",
  });

/** 获取火点考核排名 */
export const getFireWarningRanking = (params) =>
  request({
    url: "/api/realTimeSchedule/getFireWarningRanking",
    method: "get",
    params
  });

/** 获取火点时效考核数据 */
export const getFireTimelinessAssessment = (params) =>
  request({
    url: "/api/realTimeSchedule/getFireTimelinessAssessment",
    method: "get",
    params
  });

/** 火点地图-获取各乡镇设备报警数 */
export const getFireMapPoints = () =>
  request({
    url: "/api/realTimeSchedule/getFireMapTownWarnings",
    method: "get",
  });

/** 火点地图-获取乡镇点位报警详情 */
export const getFireMapPointDetail = (params) =>
  request({
    url: "/api/realTimeSchedule/getFireMapPointDetail",
    method: "get",
    params
  });
